import { render } from "./IconLinkedin.vue?vue&type=template&id=09a4ec70"
import script from "./IconLinkedin.vue?vue&type=script&lang=js"
export * from "./IconLinkedin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__